import { Select, useConfirmationDialog } from '@lbcamden/lib-react';
import { useState } from 'react';

import { useReferenceListSelectOptions, useUserStore } from '~/client/hooks/storeHooks';

type UseCloseCaseDialogParams = {
  propertyId: number;
  caseId: number;
  personId?: number;
};

export const useCloseCaseDialog = ({ propertyId, caseId, personId }: UseCloseCaseDialogParams) => {
  const userStore = useUserStore();
  const referenceListSelectOptions = useReferenceListSelectOptions();

  const [closeReasonId, setCloseReasonId] = useState<string>();

  const reasonOptions = referenceListSelectOptions('LWP_REASON');

  const handleCloseCase = () =>
    void (
      personId &&
      closeReasonId &&
      userStore?.handleAndDispatchMessage('closeCase', propertyId, {
        caseId,
        personId,
        closeReasonId,
        closeReason: reasonOptions.find(({ value }) => value === closeReasonId)?.label as string,
      })
    );

  const { show, confirmationDialog } = useConfirmationDialog({
    title: 'Close case',
    message: 'Please choose a reason for the closure of this case.',
    children: (
      <Select
        css={{ width: '100%' }}
        aria-label="Case closure reason"
        placeholder="Select a reason"
        options={reasonOptions}
        value={closeReasonId}
        onChange={setCloseReasonId}
      />
    ),
    confirmButtonProps: { disabled: !closeReasonId },
    onConfirm: handleCloseCase,
  });

  return { showCloseCaseDialog: show, closeCaseDialog: confirmationDialog };
};
